<template>
  <div>
    <b-navbar type="light" variant="light">
      <b-navbar-nav>
        <b-navbar-brand href="http://www.trend-soft.de"><img src="/trendshop.proxy.web/logo.png" height="30px"/></b-navbar-brand>
        <b-nav-item @click="open('Home')">Home</b-nav-item>

        <!-- Navbar dropdowns -->
        <b-nav-item-dropdown text="Stammdaten">
          <b-dropdown-item @click="open('ArticleList')">Artikel</b-dropdown-item>
          <b-dropdown-item @click="open('CategoryTree')">Kategorien</b-dropdown-item>
          <b-dropdown-item @click="open('ArticleSelectionList')">Sortimente</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('CustomerList')">Kunden</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Belege">
          <b-dropdown-item @click="open('OfferList')">Angebote</b-dropdown-item>
          <b-dropdown-item @click="open('OrderList')">Aufträge</b-dropdown-item>
          <b-dropdown-item @click="open('DeliveryNotes')">Lieferscheine</b-dropdown-item>
          <b-dropdown-item @click="open('InventoryList')">Inventuren</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Innendienst">
          <b-dropdown-item @click="open('ServiceRequestList')">Service Anfragen</b-dropdown-item>
          <b-dropdown-item @click="open('TaskList')">Aufgaben</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Statistik">
          <b-dropdown-item @click="open('Dashboard')">Dashboard</b-dropdown-item>
          <b-dropdown-item @click="open('ReportList')">Berichte</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="CMS">
          <b-dropdown-item @click="open('CMSUIManager','firm-ui')">Firma</b-dropdown-item>
          <!-- <b-dropdown-item @click="open('CMSUIManager','firmuser-ui')">Firmen Mitarbeiter</b-dropdown-item> -->
          <b-dropdown-divider/>
          <b-dropdown-item @click="open('CMSUIManager','ihand-ui')">iHand Home</b-dropdown-item>
          <!-- <b-dropdown-item @click="open('CMSUIManager','ihanduser-ui')">iHand Vertreter</b-dropdown-item>
          <b-dropdown-item @click="open('CMSUIManager','ihandcustomer-ui')">iHand Kunden</b-dropdown-item> -->
          <b-dropdown-divider/>
          <b-dropdown-item @click="open('CMSMailManager')">Mail Vorlagen</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Digitale Firma">
          <b-dropdown-item @click="open('PDFCatalogs')">PDF Kataloge</b-dropdown-item>
          <b-dropdown-item @click="open('GiftCardList')">Aktions Codes</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('ProcessOverview')">Prozesse</b-dropdown-item>
          <b-dropdown-item @click="open('RulesEditor')">Regeln</b-dropdown-item>
          <b-dropdown-item @click="open('ScriptTaskList')">Skripte</b-dropdown-item>
          <b-dropdown-item @click="open('RemoteServiceList')">Services</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('ChatBotConfig')">Chat Bot</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('TablesList')">Tabellen</b-dropdown-item>
          <b-dropdown-item @click="open('EventManageView')">Events</b-dropdown-item>
          <b-dropdown-item @click="open('BusinessFlows')">Business Flows</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('PasswordStore')">Passwörter</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Administration">
          <b-dropdown-item @click="open('DataMapOverview')">Daten Mapping</b-dropdown-item>
          <b-dropdown-item @click="open('DataSyncControl')">Datenabgleich</b-dropdown-item>
          <b-dropdown-item @click="open('DataBackup')">Datensicherung</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('iHandUserList')">Aussendienst</b-dropdown-item>
          <b-dropdown-item @click="open('UserList')">Benutzer</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="open('ConfigView')">Konfiguration</b-dropdown-item>
          <b-dropdown-item @click="open('ModulesOverview')">Module</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#">bShop</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item><font-awesome-icon v-if="loading" spin icon="spinner"/></b-nav-item>
        <b-nav-item><router-link to="/help" >Hilfe&nbsp;<font-awesome-icon icon="question-circle"/></router-link></b-nav-item>
        <b-nav-item @click="logout()">Abmelden&nbsp;<font-awesome-icon icon="sign-out-alt"/></b-nav-item>
      </b-navbar-nav>

    </b-navbar>
  </div>
</template>

<script>
import security from '@/modules/security.js'
import router from '../router'
import config from '@/modules/config.js'

export default {
  name: 'MenuBar',
  data() {
    return {
      rooturl: '/',
      dropdown: "",
      loading: false,
    }
  },
  created: function() {
    config.addobserver(this);
  },
  methods: {
    cfgStartLoad: function() {
      this.loading = true;
    },
    cfgStopLoad: function() {
      this.loading = false;
    },
    dropChange: function(name) {
      if (this.dropdown == name)
        this.dropdown = '';
      else
        this.dropdown = name;
    },
    open: function(view,params) {
      this.dropdown = '';
      if (params)
        router.push({ name: view, params: { area: params } });
      else
        router.push({ name: view });
    },
    logout: function() {
      security.logout();
      this.$bvModal.show('loginDialog');
      router.push('/');
    }
  },
}
</script>
